"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cancelKnock = _interopRequireDefault(require("../../../actions/knock/cancelKnock"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function cancelPresenterKnock(_ref, payload) {
  var dispatch = _ref.dispatch;
  dispatch((0, _cancelKnock["default"])(payload));
}
var _default = exports["default"] = cancelPresenterKnock;